/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAllergies} from '@fortawesome/pro-duotone-svg-icons';

const AllergyIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faAllergies} {...props} />
);

export default AllergyIcon;
